import MultiProvinceFilter from "../../Shared/MultiProvinceFilter";
import { PaginatedVacationBonusQueryVariables } from "@/graphql/__generated__/graphql";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables: PaginatedVacationBonusQueryVariables) => void;
}

/**
 * Vacation Bonus specific province filter configuration
 */
const vacationBonusProvinceConfig = {
  paginationStateKey: "paginatedVacationBonus" as keyof PaginationState,
  buildQueryVariables: (
    displayAmount: number,
    filters: any,
    provinces: string[] | null
  ): PaginatedVacationBonusQueryVariables => ({
    first: displayAmount,
    filters: {
      activeFrom: filters.activeFrom || null,
      bonusRelative: filters.bonusRelative || null,
      bonusAbsolute: filters.bonusAbsolute || null,
      provinces,
    },
  }),
  extractFilters: (paginationState: any) => paginationState?.filters || {},
};

function VacationBonusProvincesDropdown(props: Props) {
  const { displayAmount, handleSubmitClick } = props;

  return (
    <MultiProvinceFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationBonusProvinceConfig}
    />
  );
}

export default VacationBonusProvincesDropdown;
